import { render, staticRenderFns } from "./CanvasRenderer.vue?vue&type=template&id=e89ce85e"
import script from "./CanvasRenderer.vue?vue&type=script&lang=js"
export * from "./CanvasRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports